import * as Icons from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { SERVICES } from "@/lib/clinic";

function ServiceCard({ svc, idx }) {
  const Icon = Icons[svc.icon] || Icons.Stethoscope;
  const [ref, visible] = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`service-card-${svc.key}`}
      style={{ transitionDelay: visible ? `${idx * 60}ms` : "0ms" }}
      className={`group relative bg-[#FAFAF9] rounded-2xl border border-stone-200/80 p-6 sm:p-7 transition-all hover:-translate-y-1 hover:soft-shadow-lg hover:border-[#2D4A3E]/25 reveal ${
        visible ? "is-visible" : ""
      }`}
    >
      <div className="w-12 h-12 rounded-2xl bg-white border border-stone-200 flex items-center justify-center text-[#2D4A3E] group-hover:bg-[#2D4A3E] group-hover:text-white transition-colors">
        <Icon className="w-6 h-6" strokeWidth={1.5} />
      </div>
      <h3 className="mt-5 font-display font-semibold text-lg text-[#1C221F]">
        {svc.name}
      </h3>
      <p className="mt-2 text-sm text-[#57605B] leading-relaxed">
        {svc.desc}
      </p>
      <div className="mt-5 flex items-center text-sm text-[#2D4A3E] font-medium">
        <a href="#contact" className="inline-flex items-center gap-1 group-hover:gap-2 transition-all">
          Book this
          <Icons.ArrowRight className="w-4 h-4" strokeWidth={1.75} />
        </a>
      </div>
    </article>
  );
}

export default function Services() {
  const [headRef, headVis] = useReveal();
  return (
    <section
      id="services"
      data-testid="section-services"
      className="py-20 md:py-28 bg-white"
    >
      <div className="container-x">
        <div ref={headRef} className={`max-w-2xl reveal ${headVis ? "is-visible" : ""}`}>
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#2D4A3E] font-medium">
            What we do
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1C221F] tracking-tight">
            Complete dental care under one roof.
          </h2>
          <p className="mt-4 text-[#57605B]">
            From your very first cleaning to a complete smile makeover — every treatment is delivered
            with modern equipment, sterilised tools, and a whole lot of care.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICES.map((svc, i) => (
            <ServiceCard key={svc.key} svc={svc} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
